import axios from 'axios';
import cookies from 'js-cookie';

import { TOKEN_COOKIE_NAME } from '@/auth/constants';
import { TemperatureRegime } from '@/types/temperature-regime';

/**
 * Получает температурный режим по `id`
 */
export const getTemperatureCondition = async (id: string) => {
	const token = cookies.get(TOKEN_COOKIE_NAME);

	const { data } = await axios.get<TemperatureRegime>(
		`${process.env.HOST}/api_v1/temperature-conditions/${id}/`,
		{ headers: { Authorization: `Bearer ${token}` } },
	);
	return data;
};
